import { asMetric } from './asMetric';

const SUCCESS = 'success';
const FAILURE = 'failure';

const SEND_MESSAGE = 'send_message';
const SEND_MESSAGE_SUCCESS = asMetric(SEND_MESSAGE, SUCCESS);
const SEND_MESSAGE_FAILURE = asMetric(SEND_MESSAGE, FAILURE);

const API = 'api';
const FETCH_INITIAL_DATA = asMetric(API, 'fetch_initial_data');
const FETCH_INITIAL_DATA_SUCCESS = asMetric(FETCH_INITIAL_DATA, SUCCESS);
const FETCH_INITIAL_DATA_FAILURE = asMetric(FETCH_INITIAL_DATA, FAILURE);

const FETCH_INITIAL_DATA_HOURLY = asMetric(FETCH_INITIAL_DATA, 'hourly');
const FETCH_INITIAL_DATA_HOURLY_SUCCESS = asMetric(FETCH_INITIAL_DATA_HOURLY, SUCCESS);
const FETCH_INITIAL_DATA_HOURLY_FAILURE = asMetric(FETCH_INITIAL_DATA_HOURLY, FAILURE);

export {
    SEND_MESSAGE,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_FAILURE,
    FETCH_INITIAL_DATA_SUCCESS,
    FETCH_INITIAL_DATA_FAILURE,
    FETCH_INITIAL_DATA_HOURLY_SUCCESS,
    FETCH_INITIAL_DATA_HOURLY_FAILURE
};
